"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truthyOrArrayPredicate = exports.truthyAndArrayPredicate = exports.isStrictEqual = exports.isBrowser = exports.noop = void 0;
const noop = () => { };
exports.noop = noop;
exports.isBrowser = typeof window !== 'undefined' &&
    typeof navigator !== 'undefined' &&
    typeof document !== 'undefined';
/**
 * You should only be reaching for this function when you're attempting to prevent multiple
 * redefinitions of the same function. In-place strict equality checks are more performant.
 */
const isStrictEqual = (prev, next) => prev === next;
exports.isStrictEqual = isStrictEqual;
const truthyAndArrayPredicate = (conditions) => conditions.every(Boolean);
exports.truthyAndArrayPredicate = truthyAndArrayPredicate;
const truthyOrArrayPredicate = (conditions) => conditions.some(Boolean);
exports.truthyOrArrayPredicate = truthyOrArrayPredicate;
